import { render, staticRenderFns } from "./EnvironmentItem.vue?vue&type=template&id=36f81f68&"
import script from "./EnvironmentItem.vue?vue&type=script&lang=js&"
export * from "./EnvironmentItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports